<script setup lang="ts">
import DiscrepancyStats from 'Common/components/elements/feedback/DiscrepancyStats.vue'
import type { WorkcardDetailedStatsType } from 'Modules/types/pages/workcard/workcardDetailedStatsType'

interface PropTypes {
  stats: {
    discrepancies: {
      requires_inspection: number
      grounding_condition: number
      non_grounding_condition: number
      for_awareness:number,
      suggestion: number,
      total: number
    }
  }
}

const props = defineProps<PropTypes>()
</script>

<template>
  <div>
    <div>
      <div class="text-lg font-bold text-gray-700 mb-4">Discrepancies by Severity</div>
    </div>
    <div class="p-3 ">
      <DiscrepancyStats
        v-if="props.stats.discrepancies"
        :requires-inspection="props.stats.discrepancies.requires_inspection"
        :grounding-condition="props.stats.discrepancies.grounding_condition"
        :non-grounding-condition="props.stats.discrepancies.non_grounding_condition"
        :for-awareness="props.stats.discrepancies.for_awareness"
        :suggestion="props.stats.discrepancies.suggestion"
        :total="props.stats.discrepancies.total"
      />
    </div>
  </div>
</template>
<style>
.sectioned-variable-progress-bar-wrapper{
  margin-bottom: 0;
}
.sectioned-progress-root, .progress-bar-inner {
  height: 6px;
}
</style>